import React, { useState } from "react";
import { useSetState } from "../../../utils/hooks";
import Filter from "../Components/Filter";
import { NotificationTable } from "./notification-table";

const PushNotificationList = () => {
  const [filter, dispatchFilter] = useSetState();
  const [sort, dispatchSort] = useSetState();
  const [immediate, setImmediate] = useState("");
  const [selectedFilter, setSelectedFilter] = React.useState({});

  const onSubmitFilter = () => {
    setSelectedFilter({ ...filter, immediate });
  };

  const onResetFilter = () => {
    setSelectedFilter({ immediate, title: "", status: "" });
    dispatchFilter({ immediate, title: "", status: "" });
  };
  const onChangeType = (selectedMode) => {
    setSelectedFilter({ immediate: selectedMode });
    setImmediate(selectedMode);
  };
  return (
    <div className="-mt-2">
      <h1 className="text-base font-bold">푸시알림 발송 리스트</h1>
      <div className="flex mt-4">
        <div
          onClick={() => onChangeType("")}
          className={`cursor-pointer w-[120px] flex justify-center items-center ${
            immediate === ""
              ? "bg-primary-blue text-white"
              : "text-[#999999] border border-[#dddddd]"
          } py-2`}
        >
          전체
        </div>
        <div
          onClick={() => onChangeType("true")}
          className={`cursor-pointer w-[120px] flex justify-center items-center ${
            immediate === "true"
              ? "bg-primary-blue text-white"
              : "text-[#999999] border border-[#dddddd]"
          } py-2`}
        >
          즉시 발송
        </div>
        <div
          onClick={() => onChangeType("false")}
          className={`cursor-pointer w-[120px] flex justify-center items-center ${
            immediate === "false"
              ? "bg-primary-blue text-white"
              : "text-[#999999] border border-[#dddddd]"
          } py-2`}
        >
          예약 발송
        </div>
      </div>
      <Filter
        onSubmitFilter={onSubmitFilter}
        onFilter={dispatchFilter}
        onResetFilter={onResetFilter}
        filter={filter}
        setImmediate={setImmediate}
      />
      <NotificationTable
        onSort={dispatchSort}
        sort={sort}
        filter={selectedFilter}
      />
      {/* <div className="my-28 text-center text-title-grey">등록된 내역이 없습니다.</div> */}
    </div>
  );
};

export default PushNotificationList;
